import React from 'react';
import { useD3 } from '../../hooks/useD3';
import forceSimulation from '../../util/d3/forceSimulation';

import { Data } from '../../types';

import '../../styles/ForceChart.css';

type Props = {
  data: Data;
  updateNode: (value: string) => void;
}

const ForceChart = ({ data, updateNode }: Props) => {

  const ref = useD3(
    (svg: any) => forceSimulation(svg, data, updateNode),
    [data]
  );

  return (
    <div className="be_ForceChart">
      <figure className="be_ForceChartFigure">
        <svg
          ref={ref}
          id='be_graph'
        >
        </svg>
      </figure>
    </div>
  );
};

export default ForceChart;